// extracted by css-extract-rspack-plugin
export default {"employerInfo":"employer-info--d1imUgvQNEyMvvDR","employerInfoButton":"employer-info-button--rGM7fiFjEiI0HEqJ"};